import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    maxHeight: "calc(100vh - 200px)",
    overflow: "hidden",
    padding: "16px",
  },
  permissionItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#999",
      background: "#f9f9f9",
    },
  },
  permissionLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#333",
  },
  switchControl: {
    margin: 0,
  },
}));

const PermissionsModal = ({ open, onClose, user, onSave }) => {
  const classes = useStyles();
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    if (user && open) {
      console.log("Dados do usuário recebidos:", user);
      
      // Função auxiliar para normalizar valores para boolean
      const toBoolean = (value) => {
        if (value === undefined || value === null) return false;
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
          return value === "enabled" || value === "true" || value === "1";
        }
        return Boolean(value);
      };
      
      setPermissions({
        allowGroup: toBoolean(user.allowGroup),
        allHistoric: toBoolean(user.allHistoric),
        allUserChat: toBoolean(user.allUserChat),
        userClosePendingTicket: toBoolean(user.userClosePendingTicket),
        allowSeeMessagesInPendingTickets: toBoolean(user.allowSeeMessagesInPendingTickets),
        showDashboard: toBoolean(user.showDashboard),
        allowRealTime: toBoolean(user.allowRealTime),
        allowConnections: toBoolean(user.allowConnections),
        showContacts: toBoolean(user.showContacts),
        showCampaign: toBoolean(user.showCampaign),
        showFlow: toBoolean(user.showFlow),
        finalizacaoComValorVendaAtiva: toBoolean(user.finalizacaoComValorVendaAtiva),
      });
    }
  }, [user, open]);

  const handlePermissionToggle = (field) => {
    setPermissions(prev => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSave = () => {
    // allowGroup e finalizacaoComValorVendaAtiva são boolean no banco
    // Os outros são string "enabled"/"disabled"
    const dataToSave = {
      allowGroup: Boolean(permissions.allowGroup),
      allHistoric: permissions.allHistoric ? "enabled" : "disabled",
      allUserChat: permissions.allUserChat ? "enabled" : "disabled",
      userClosePendingTicket: permissions.userClosePendingTicket ? "enabled" : "disabled",
      allowSeeMessagesInPendingTickets: permissions.allowSeeMessagesInPendingTickets ? "enabled" : "disabled",
      showDashboard: permissions.showDashboard ? "enabled" : "disabled",
      allowRealTime: permissions.allowRealTime ? "enabled" : "disabled",
      allowConnections: permissions.allowConnections ? "enabled" : "disabled",
      showContacts: permissions.showContacts ? "enabled" : "disabled",
      showCampaign: permissions.showCampaign ? "enabled" : "disabled",
      showFlow: permissions.showFlow ? "enabled" : "disabled",
      finalizacaoComValorVendaAtiva: Boolean(permissions.finalizacaoComValorVendaAtiva),
    };
    console.log("Salvando permissões (tipos corretos):", dataToSave);
    onSave(dataToSave);
    onClose();
  };



  const permissionsList = [
    { key: "allowGroup", label: "Permitir Grupos" },
    { key: "allHistoric", label: i18n.t("userModal.form.allHistoric") },
    { key: "allUserChat", label: i18n.t("userModal.form.allUserChat") },
    { key: "userClosePendingTicket", label: i18n.t("userModal.form.userClosePendingTicket") },
    { key: "allowSeeMessagesInPendingTickets", label: i18n.t("userModal.form.allowSeeMessagesInPendingTickets") },
    { key: "showDashboard", label: i18n.t("userModal.form.showDashboard") },
    { key: "allowRealTime", label: i18n.t("userModal.form.allowRealTime") },
    { key: "allowConnections", label: i18n.t("userModal.form.allowConnections") },
    { key: "showContacts", label: i18n.t("userModal.form.showContacts") },
    { key: "showCampaign", label: i18n.t("userModal.form.showCampaign") },
    { key: "showFlow", label: i18n.t("userModal.form.showFlow") },
    { key: "finalizacaoComValorVendaAtiva", label: "Finalização com Valor de Venda" },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Gerenciar Permissões {user && `- ${user.name}`}
      </DialogTitle>
      <DialogContent dividers className={classes.dialogContent}>
        <Grid container spacing={2}>
          {permissionsList.map((perm) => (
            <Grid item xs={12} sm={6} key={perm.key}>
              <div className={classes.permissionItem}>
                <span className={classes.permissionLabel}>
                  {perm.label}
                </span>
                <FormControlLabel
                  className={classes.switchControl}
                  control={
                    <Switch
                      checked={Boolean(permissions[perm.key])}
                      onChange={() => handlePermissionToggle(perm.key)}
                      color="primary"
                    />
                  }
                  label={permissions[perm.key] ? "Ativo" : "Inativo"}
                />
              </div>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PermissionsModal;
